var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full min-h-screen overflow-y-auto",attrs:{"id":"app"}},[_c('toast'),_c('login-modal'),_c('stack',[_vm._t("default")],2),_c('cookie-bar'),_c('portal-target',{attrs:{"name":"modal","tag":"div"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }